<template>
  <div>
    <div v-if="tickets.length > 0">
      <div
        v-if="!compactView"
        class="d-flex justify-content-between"
      >
        <div>
          <b-form-checkbox
            v-show="tickets.length < maxTicketAsCardMode"
            v-model="viewMode"
            class="custom-control-secondary mb-2"
            switch
          >
            <span class="switch-icon-left">
              <feather-icon icon="GridIcon" />
            </span>
            <span class="switch-icon-right">
              <feather-icon icon="ListIcon" />
            </span>
          </b-form-checkbox>
        </div>
        <slot name="topRight" />
      </div>
      <div
        v-show="!viewMode"
      >
        <div class="d-flex">
          <ticket-card
            v-for="(ticket, index) in tickets"
            :id="ticket.id"
            :key="ticket.id"
            :row="ticket.row_sector"
            :seat="ticket.seat_number"
            :price="ticket.new_price !== undefined && ticket.new_price !== null ? ticket.new_price : ticket.price"
            :new-price="null"
            :strike-price="false"
            :view-mode="(compactView) ? 'compact-card' : 'card'"
            :label="ticket.sector_name"
            :can-select="canSelect"
            :is-selected="selectedList.includes(ticket.id)"
            :status="ticket.status"
            :ticket-number="ticket.ticket_number"
            :tickets-count="tickets.length"
            :index="(index + 1)"
            @remove="removeTicket"
            @select="selectTicket"
            @unSelect="unSelectTicket"
          />
        </div>
      </div>
      <div v-if="viewMode">
        <b-table
          ref="ticketsTable"
          :items="fetchTickets"
          responsive
          :fields="ticketsTableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          :sort-desc.sync="isSortDirDesc"
          :sticky-header="stickyHeader"
        >
          <template #head(checkbox)="data">
            <b-form-checkbox
              v-model="checkAll"
              class="custom-control-primary"
            />
          </template>
          <template #head(action)="data">
            <div class="text-right">
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
              />
            </div>
          </template>
          <template #cell(checkbox)="data">
            <b-form-checkbox
              v-model="selectedList"
              class="custom-control-primary"
              :value="data.item.id"
              :disabled="['returned', 'revoked'].includes(data.item.status)"
            />
          </template>
          <template #cell(status)="data">
            <b-badge
              v-if="data.item.status.length > 0"
              :variant="getOrderStatusVariant(data.item.status)"
            >
              {{ getOrderStatusName(data.item.status) }}
            </b-badge>
          </template>
          <template #cell(scanned_at)="data">
            <span
              v-if="data.item.scanned_at !== null"
              :id="`scan-${data.item.id}`"
              style="cursor: pointer;"
              @click="resetScanStatus(data.item.id)"
            >
              <feather-icon
                icon="CheckCircleIcon"
                class="text-success"
              />
              <b-tooltip
                triggers="hover"
                :target="`scan-${data.item.id}`"
                :title="`${data.item.scanned_at}`"
                :delay="{ show: 500, hide: 50 }"
              />
            </span>
            <feather-icon
              v-else
              icon="MinusCircleIcon"
              class="text-gray"
            />
          </template>
          <template #cell(price)="data">
            <span>{{ data.item.price }}</span>
          </template>
          <template #cell(basic_amount)="data">
            <s v-if="data.item.new_price !== null">{{ data.item.basic_amount }}</s>
            <span v-else>{{ data.item.basic_amount }}</span>
          </template>
        </b-table>
      </div>
      <div
        v-if="!compactView"
        class="mt-2 d-flex justify-content-between"
      >
        <div>
          <span>Всего билетов: <b>{{ tickersCount }} шт.</b></span>

          <span class="ml-2">Сумма: <b>{{ formatMoney(totalPrice, 'rub') }}</b></span>
        </div>
        <div>
          <slot name="bottomRight" />
        </div>
      </div>
      <div
        v-if="hasOrder"
        class="mt-1"
      >
        <div
          v-for="([status, data]) in Object.entries(statusListCount)"
          :key="status"
        >
          {{ statusesHelper[status].label }}: <b>{{ data.count }} шт. = {{ formatMoney(data.total, 'rub') }}</b>
        </div>
      </div>
    </div>
    <div
      v-if="orderData && ['issued', 'payed', 'completed'].includes(orderData.status) && orderData.labelLoyaltyName"
      class="mt-2 d-flex justify-content-between"
    >
      <div>
        <span>Использовано: <b>{{ orderData.labelLoyaltyName }}</b></span>
      </div>
    </div>
    <div class="order-print">
      <div class="ticket-controls__buttons">
        <b-button
          v-if="isCompleted"
          v-b-modal="'prepare-form-send-email'"
          variant="light"
        >
          <feather-icon
            icon="EmailIcon"
            size="16"
            class="mr-50"
          />
          Отправить email
        </b-button>

        <b-button
          v-if="isPrintable"
          variant="light"
          @click="ticketsPrint('a4')"
        >
          <feather-icon
            icon="PrinterIcon"
            size="16"
            class="mr-50"
          />
          Распечатать A4
        </b-button>

        <b-button
          v-if="isPrintable"
          variant="light"
          @click="ticketsPrint('a5')"
        >
          <feather-icon
            icon="PrinterIcon"
            size="16"
            class="mr-50"
          />
          Распечатать A5
        </b-button>

        <b-button
          v-if="isPrintable"
          variant="light"
          :disabled="state.downloadButtonDisabled"
          @click="ticketsDownload"
        >
          <feather-icon
            icon="DownloadIcon"
            size="16"
            class="mr-50"
          />
          Скачать
        </b-button>

      </div>

      <!-- Buttons: Delete -->
      <div class="order-print__footer">
        <b-button
          v-if="isNotCancelled"
          variant="danger"
          :disabled="!showRemoveBtn || orderData.seller.type === 'gate'"
          @click="$emit('tickets-delete')"
        >
          <feather-icon
            icon="TrashIcon"
            size="16"
            class="mr-50"
          />
          {{ cancelButtonStatusName }} выбранные
        </b-button>
      </div>
    </div>
    <!--  todo компонент формы  -->
    <PrepareFormSendEmail
      v-if="isPrepareFormSendEmailActive"
      :order-data.sync="orderData"
      :prepare-send-email="sendEmails"
    />
  </div>
</template>

<script>
import {
  computed, onMounted, reactive, ref, watch, watchEffect,
} from '@vue/composition-api'
import {
  BTable,
  BFormCheckbox,
  BBadge,
  BTooltip,
  BButton,
} from 'bootstrap-vue'
import moment from 'moment-timezone'
import helpers from '@/mixins/globalHelpers'
import oldFunctions from '@/helpers/oldFunctions.module'
import store from '@/store'

import toastService from '@/services/toastService'

import TicketCard from './TicketCard'
import { statuses } from '../../helpers/lists'
import PrepareFormSendEmail from '../orders/PrepareFormSendEmail.vue'

moment.tz.setDefault('UTC')

export default {
  name: 'TicketList',
  components: {
    PrepareFormSendEmail,
    BButton,
    TicketCard,
    BFormCheckbox,
    BTable,
    BBadge,
    BTooltip,
  },
  emits: ['select', 'unSelect'],
  mixins: [helpers],
  props: {
    tickets: {
      type: Array,
      required: true,
    },
    canSelect: {
      type: Boolean,
      default: false,
    },
    showStatus: {
      type: Boolean,
      default: true,
    },
    showTicketNumber: {
      type: Boolean,
      default: true,
    },
    compactView: {
      type: Boolean,
      default: false,
    },
    maxTicketAsCardMode: {
      type: Number,
      default: 5,
    },
    returned: {
      type: Boolean,
      default: false,
    },
    showRemoveBtn: {
      type: Boolean,
    },
    selectedTickets: {
      type: Array,
      default: () => [],
    },
    orderData: {
      type: Object,
      default: () => {},
    },
    cancelButtonStatusName: {
      type: String,
      default: 'Удалить',
    },
    canResetEntry: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statusesHelper: statuses,
    }
  },
  setup(props, { emit }) {
    const state = reactive({
      downloadButtonDisabled: false,
    })

    const {
      ticketsDownloadOld,
      ticketsPrintOld,
      sendEmailsOld,
    } = oldFunctions()

    const isPrepareFormSendEmailActive = ref(false)

    const isCompleted = computed(() => props.orderData && props.orderData.status === 'completed')
    const isPrintable = computed(() => props.orderData && !['created', 'booked', 'cancelled'].includes(props.orderData.status))
    const isNotCancelled = computed(() => props.orderData && props.orderData.status !== 'cancelled')

    const stickyHeader = ref(true)
    const ticketsTable = ref(null)
    const selectedList = ref([])
    const viewMode = ref(false)
    const oldPrice = () => props.tickets.map(item => item.price).reduce((prev, curr) => prev + curr, 0)
    const hasOrder = computed(() => Object.keys(props.orderData || {}).length > 0)
    const hasQuotaTickets = computed(() => props.tickets.some(item => item.quota_id))
    // const maxTicketAsCardMode = 5
    const tableMaxVisibleTickets = 6
    const ticketsTableColumns = computed(() => [
      {
        key: 'checkbox',
        sortable: false,
        label: '',
        thStyle: { width: '1%' },
        thClass: (!props.canSelect) ? 'd-none' : '',
        tdClass: (!props.canSelect) ? 'd-none' : '',
      },
      { key: 'sector_name', sortable: true, label: 'Зона' },
      { key: 'row', sortable: true, label: 'Ряд' },
      { key: 'seat_number', sortable: true, label: 'Место' },
      {
        key: 'ticket_number',
        sortable: true,
        label: 'Билет',
        thClass: (!props.showTicketNumber) ? 'd-none' : '',
        tdClass: (!props.showTicketNumber) ? 'd-none' : '',
      },
      {
        key: 'status',
        sortable: true,
        label: 'Статус',
        thClass: (!props.showStatus) ? 'd-none' : '',
        tdClass: (!props.showStatus) ? 'd-none' : '',
      },
      {
        key: 'scanned_at',
        sortable: true,
        label: 'QR',
        thClass: 'text-center',
        tdClass: 'text-center',
      },
      {
        key: 'price',
        sortable: true,
        label: 'Цена',
        thClass: (!props.showStatus) ? 'd-none' : '',
        tdClass: (!props.showStatus) ? 'd-none' : '',
      },
      {
        key: 'basic_amount',
        sortable: true,
        label: 'Базовая стоимость',
        thClass: (!props.showStatus) ? 'd-none' : '',
        tdClass: (!props.showStatus) ? 'd-none' : '',
      },
      {
        key: 'quota',
        sortable: true,
        label: 'Квота',
        thClass: (!hasQuotaTickets.value) ? 'd-none' : '',
        tdClass: (!hasQuotaTickets.value) ? 'd-none' : '',
      },
      // {
      //   key: 'action', sortable: false, label: '', thStyle: { width: '1%' },
      // },
    ])
    const defaultSorting = 'sector_name'
    const sortBy = ref(defaultSorting)
    const isSortDirDesc = ref(false)
    const checkAll = ref(false)
    stickyHeader.value = props.tickets.length > tableMaxVisibleTickets
    viewMode.value = props.tickets.length >= props.maxTicketAsCardMode
    watch(() => props.tickets, () => {
      // viewMode.value = props.tickets.length >= props.maxTicketAsCardMode
      if (props.tickets.length >= props.maxTicketAsCardMode) {
        viewMode.value = true
      }

      if (ticketsTable.value !== null) {
        ticketsTable.value.refresh()
      }

      stickyHeader.value = props.tickets.length > tableMaxVisibleTickets
    })

    const fetchTickets = () => {
      const tickets = props.tickets.map(item => ({
        id: item.id,
        zone: item.zone || '—',
        row: item.row_sector,
        sector_name: item.sector_name,
        seat_number: +item.seat_number,
        ticket_number: item.ticket_number,
        status: item.status || '',
        scanned_at: item.scanned_at ? moment(item.scanned_at).locale('ru').format('D.MM.YYYY, HH:mm') : null,
        price: item.new_price ?? item.price,
        new_price: item.new_price,
        basic_amount: item.basic_amount,
        quota_id: item.quota_id,
        quota: item.quota || '-',
      }))

      if (sortBy.value === defaultSorting) {
        if (isSortDirDesc.value) {
          tickets.sort((a, b) => b.sector_name.localeCompare(a.sector_name) || a.row - b.row || a.seat_number - b.seat_number)
        } else {
          tickets.sort((a, b) => a.sector_name.localeCompare(b.sector_name) || a.row - b.row || a.seat_number - b.seat_number)
        }
      } else {
        tickets.sort((a, b) => {
          if (a[sortBy.value] < b[sortBy.value]) {
            return isSortDirDesc.value ? 1 : -1
          }

          return isSortDirDesc.value ? -1 : 1
        })
      }

      return tickets
    }

    const removeTicket = id => {
      emit('remove', id)
    }
    const selectTicket = id => {
      if (!selectedList.value.includes(id)) {
        selectedList.value.push(id)
        emit('input', selectedList.value)
      }
    }

    const unSelectTicket = id => {
      if (selectedList.value.includes(id)) {
        selectedList.value = selectedList.value.filter(item => item !== id)
        emit('input', selectedList.value)
      }
    }

    const ticketsDownload = () => {
      const useOldTicketGenerationType = store.state.app.settings.use_old_ticket_generation_type
      if (useOldTicketGenerationType) {
        return ticketsDownloadOld(props.orderData, props.selectedTickets, disabled => { state.downloadButtonDisabled = disabled })
      }

      state.downloadButtonDisabled = true

      const url = new URL(
        `/orders/${props.orderData.id}/tickets?token=${props.orderData.token}&action=download`,
        window.location,
      )

      props.selectedTickets.forEach(id => {
        url.searchParams.append('seats[]', id)
      })

      window.open(url.toString(), '_blank')

      setTimeout(() => { state.downloadButtonDisabled = false }, 3000)
      return undefined
    }

    const ticketsPrint = format => {
      const useOldTicketGenerationType = store.state.app.settings.use_old_ticket_generation_type
      if (useOldTicketGenerationType) {
        return ticketsPrintOld(props.orderData, props.selectedTickets, format)
      }
      const url = new URL(
        `/orders/${props.orderData.id}/tickets?token=${props.orderData.token}&format=${format}&action=print`,
        window.location,
      )

      props.selectedTickets.forEach(id => {
        url.searchParams.append('seats[]', id)
      })

      window.open(url.toString(), '_blank')
      return undefined
    }

    const sendEmails = sendData => {
      const useOldTicketGenerationType = store.state.app.settings.use_old_ticket_generation_type

      if (useOldTicketGenerationType) {
        sendEmailsOld(sendData)
          .then(result => {
            if (!result.success) {
              toastService.error(result.message)
            } else {
              toastService.success(result.message)
            }
          })

        return undefined
      }

      const { orderData, selectedTickets } = props

      const url = new URL(
        `/orders/${orderData.id}/tickets?token=${orderData.token}&action=mail`,
        window.location,
      )

      selectedTickets.forEach(id => {
        url.searchParams.append('seats[]', id)
      })

      // todo добавляем параметры
      url.searchParams.append('sendName', sendData.name)
      url.searchParams.append('sendEmail', sendData.email)
      url.searchParams.append('sendIsAddLink', sendData.is_add_link)

      window.open(url.toString(), '_blank')
      return undefined
    }

    const resetScanStatus = (ticketId) => {
      if (!props.canResetEntry) {
        toastService.error('У вас нет прав на сброс метки прохода')
        return
      }

      if (confirm('Снять метку прохода?')) {
        store.dispatch('api/resetTicketScan', ticketId)
          .then(response => {
            toastService.success('Метка прохода успешно снята')
            emit('update-ticket-mark', ticketId)
            ticketsTable.value.refresh()
          })
          .catch(error => {
            toastService.error(error.response?.data?.message || 'Ошибка при сбросе метки прохода')
          })
      }
    }

    watch(selectedList, () => {
      emit('input', selectedList.value)

      // Count only non-disabled tickets
      const selectableTickets = props.tickets.filter(item => !['returned', 'revoked'].includes(item.status))
      checkAll.value = selectedList.value.length === selectableTickets.length && selectableTickets.length > 0
    })

    watch(checkAll, v => {
      if (v) {
        // Only select tickets that are not returned or revoked
        selectedList.value = props.tickets
          .filter(item => !['returned', 'revoked'].includes(item.status))
          .map(item => item.id)
      } else {
        selectedList.value = []
      }
    })

    const totalPrice = ref(0)
    const tickersCount = ref(0)
    const statusListCount = ref({})

    watchEffect(() => {
      if (props.tickets.length > 0) {
        const filteredTickets = props.tickets.filter(item => {
          if (props.returned) {
            return item.status === 'returned' || item.status === 'revoked'
          }
          return item.status !== 'returned' && item.status !== 'revoked'
        })

        const effectiveTickets = (props.returned && filteredTickets.length === 0)
          ? props.tickets
          : filteredTickets

        totalPrice.value = filteredTickets
          .map(item => item.new_price ?? item.price)
          .reduce((sum, current) => sum + current, 0)

        if (hasOrder) {
          statusListCount.value = props.tickets.reduce((acc, ticket) => {
            const { status, price, new_price } = ticket
            const thisPrice = new_price ?? price
            if (!acc[status]) {
              acc[status] = { count: 0, total: 0 }
            }
            acc[status].count = (acc[status].count || 0) + 1
            acc[status].total = (acc[status].total || 0) + thisPrice
            return acc
          }, {})
        }

        tickersCount.value = filteredTickets.length
      } else {
        totalPrice.value = 0
        tickersCount.value = 0
      }
    })

    onMounted(() => {
      if (props.orderData) {
        isPrepareFormSendEmailActive.value = true
      }
    })

    return {
      state,
      isPrepareFormSendEmailActive,

      isCompleted,
      isPrintable,
      isNotCancelled,

      tickersCount,
      totalPrice,
      oldPrice,
      viewMode,
      // maxTicketAsCardMode,
      removeTicket,
      selectedList,
      selectTicket,
      unSelectTicket,
      ticketsTableColumns,
      fetchTickets,
      sortBy,
      isSortDirDesc,
      checkAll,
      ticketsTable,
      stickyHeader,

      ticketsDownload,
      ticketsPrint,
      sendEmails,
      statusListCount,
      hasOrder,
      resetScanStatus,
    }
  },
}
</script>

<style>
.ticket-controls__buttons {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    &__footer{
        flex: 1 0 100%;
        max-width: 100%;
    }
    @media ( max-width: 767px) {
        .btn{
            width: 100%;
        }
    }
}

.order-print__footer {
    margin-top: 10px;
}

</style>
